<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader && user) {
    <div
        menuSystem
        [cerrixTab]="tab"
        class="user-detail"
        data-uiid="user-detail"
        (changeEvent)="handleMenuItemClick($event)"
    >
        @if (!hideSaveBar) {
            <div class="detail-page-action-bar">
                <button
                    class="btn btn-cerrix"
                    (click)="save()"
                    [disabled]="!canSave"
                    data-uiid="save-user-btn"
                >
                    <i class="fas fa-save"></i>
                    <span class="d-none d-lg-inline">Save user</span>
                </button>

                @if (user.lastLogin) {
                    <span class="date-edited"
                        >Last login: {{ user.lastLogin | dateTimeFormat }}</span
                    >
                } @else {
                    @if (!isNewUserRequest) {
                        <span class="date-edited">User did not login yet.</span>
                    }
                }

                <div class="workflow-area">
                    @if (user.failedLogins > 0) {
                        <span class="workflow-description">
                            @if (user.dateLocked) {
                                <span
                                    >Locked since <b>{{ user.dateLocked | dateTimeFormat }}</b> and
                                    <b>{{ user.failedLogins }}</b> failed logins total.</span
                                >
                            } @else {
                                <span
                                    >User currently has <b>{{ user.failedLogins }}</b> failed
                                    login{{ user.failedLogins > 1 ? "s" : "" }}.</span
                                >
                            }
                        </span>
                    }
                    @if (user.dateLocked) {
                        <button
                            class="btn btn-outline-secondary"
                            data-uiid="user-detail-unlock-button"
                            (click)="unlockUser()"
                            [disabled]="!permissions.canLockUnlock"
                        >
                            <i class="fas fa-lock-open"></i>
                            <span class="d-none d-lg-inline ms-2">Unlock user</span>
                        </button>
                    }
                </div>
            </div>
        }

        <div
            class="user-screens full-height"
            [attr.name]="'User management'"
            menuicon="fas fa-user-cog"
            menusystemsubmenu
        >
            <div name="Profile" menuicon="fas fa-user" menusystemitem>
                <user-info [user]="user" [sd]="sd" [permissions]="permissions"></user-info>
            </div>
            @if (user) {
                <div
                    data-uiid="userdetail-notification-settings"
                    name="Notification Settings"
                    menuItemId="notification-settings"
                    menuicon="fas fa-bell"
                    menusystemitem
                >
                    <user-notification-settings
                        [userModel]="user"
                        [parentTab]="tab"
                        [showSave]="false"
                    ></user-notification-settings>
                </div>
            }
            @if (permissions.canAssignRoles) {
                <div
                    data-uiid="userdetail-roles"
                    name="Roles"
                    menuItemId="roles"
                    menuicon="fas fa-user-tag"
                    menusystemitem
                >
                    <user-roles [user]="user" [sd]="sd" [permissions]="permissions"></user-roles>
                </div>
            }
            @if (permissions.canEditLogins) {
                <div name="Authentication" menuicon="fas fa-user-shield" menusystemitem>
                    <user-logins [user]="user" [sd]="sd" [permissions]="permissions"></user-logins>
                </div>
            }
            @if (!isNewUserRequest) {
                @if (permissions.canViewApiKeys) {
                    <div
                        class="full-height"
                        name="API Keys"
                        menuItemId="apikeytab"
                        menuicon="fas fa-key"
                        menusystemitem
                    >
                        <api-key-overview [userGuid]="user.guid"></api-key-overview>
                    </div>
                }
                @if (permissions.canViewAudit) {
                    <div
                        class="full-height"
                        name="Audit"
                        menuItemId="audittab"
                        menuicon="fas fa-user-friends"
                        menusystemitem
                    >
                        <user-audit [user]="user" #audit></user-audit>
                    </div>
                }
                @if (permissions.canViewHistory) {
                    <div
                        name="History"
                        menuItemId="historytab"
                        menuicon="fas fa-user-clock"
                        menusystemitem
                    >
                        <user-history [user]="user" #history></user-history>
                    </div>
                }
                @if (permissions.canDelete) {
                    <div name="Options" menuicon="fas fa-check-double" menusystemitem>
                        <detail-options
                            moduleName="user"
                            [objectName]="'user'"
                            [allowDelete]="true"
                            (onDelete)="delete()"
                        >
                        </detail-options>
                    </div>
                }
            }
        </div>
    </div>
}
